import { forwardRef } from 'react';
import { MenuItem } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const ItemPlaceholder = forwardRef(({ className, item }, ref) => {
  const styles = useStyles();

  return (
    <MenuItem
      className={cx(styles.root, className)}
      ref={ref}
      disabled
    >
      {item.label}
    </MenuItem>
  );
});

ItemPlaceholder.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

ItemPlaceholder.defaultProps = {
  className: '',
};
